<template>
  <form class="step-two" @submit.prevent="onSubmitIntegration">
    <p class="description">{{$t('signupflow.step-2.description')}}</p>
    <CustomSelect
      :disabled="!!createdIntegration"
      class="integration-select"
      v-model="connectorType"
      :options="connectors"
      :legend="$t('signupflow.step-2.select.placeholder')"
      :label="$t('signupflow.step-2.select.label')"
      optionHasImgSources
    />

    <span class="leave-flow-text text-muted" @click="onCancelFlow">{{$t('signupflow.step-2.cancel-btn')}}</span>

    <div v-if="connectorType && ready" class="dynamic-connector-wrapper">
      <h3>{{$t('signupflow.step-2.sub-title')}}</h3>
      <p class="description" v-html="connectorSetup.setupDescription"></p>
      <a :href="connectorSetup.guideLink" target="_blank">{{ connectorSetup.guideText }}</a>
      <DynamicForm
        class="dynamic-form"
        :formData="connectorSetup.form"
        :source="connectorSource"
        :formDataIndex="0"
        :ignoreInvalid="ignoreInvalid"
        @changes="changesMade"
        boxed
      />
      <button class="btn-signup-flow" type="submit" :disabled="!valid">
        {{ primaryButtonMessage }} <span v-show="loading"><i class="fa-light fa-circle-notch fa-spin"></i></span>
      </button>
    </div>

    <div v-if="connectionError" class="connection-error">
      <h4>{{$t('signupflow.step-2.connection-error.title')}}</h4> 
      <p class="description">{{$t('signupflow.step-2.connection-error.description')}}</p>
      <p class="description" v-if="connectionMessage">
        {{$t('signupflow.step-2.connection-error.error-description')}} <span class="text-danger">{{ connectionMessage }}</span>
      </p>
      <p class="description">{{$t('signupflow.step-2.connection-error.check-info-description')}}</p>
      <button type="button" @click="proceed(false)">{{$t('signupflow.step-2.connection-error.opt-out-btn')}}</button>
    </div>
    <div v-if="showOkMessage && !connectionError" class="ok-message">
      <h4>{{$t('signupflow.step-2.connection-restored.title')}}</h4>
      <p class="description text-success">{{$t('signupflow.step-2.connection-restored.description')}}</p>
      <button type="button" @click="proceed(true)">{{$t('signupflow.step-2.connection-restored.proceed-btn')}}</button>
    </div>
    <transition name="quick-fade-in">
      <div v-if="noIntegrationOption" class="no-integration-option">
        <h4>{{$t('signupflow.step-2.no-connector.title')}}</h4>
        <p class="description">
          {{$t('signupflow.step-2.no-connector.description')}}
        </p>
        <ul>
          <li>{{$t('signupflow.step-2.no-connector.sheets')}}</li>
          <li>
            {{$t('signupflow.step-2.no-connector.xml')}} <br />
            <span class="text-muted text-small">{{$t('signupflow.step-2.no-connector.xml-small')}}</span>
          </li>
          <li>{{$t('signupflow.step-2.no-connector.api')}}</li>
        </ul>
        <button type="button" class="btn-signup-flow" @click="cancelFlow()">{{$t('signupflow.step-2.no-connector.cancel-btn')}}</button>
      </div>
    </transition>
  </form>
</template>

<script>
import Connector from "@/assets/js/connector.js";
import appHelper from "@/assets/js/appHelper.js";
import CustomSelect from "@/components/CustomSelect";
import DynamicForm from "@/components/DynamicForm";
import quickConnectors from "@/assets/js/quickConnectors.js";
export default {
  components: { CustomSelect, DynamicForm },
  data() {
    return {
      connectorType: null,
      connectors: [
        { value: "Shopify", name: "Shopify", imgSrc: "integration-icons/shopifyicon.svg" },
        { value: "WooCommerce", name: "WooCommerce", imgSrc: "integration-icons/woocommerceicon.svg" },
        { value: "DanDomainClassic", name: "DanDomain Classic", imgSrc: "integration-icons/dandomainlogo.png" },
        { value: "Shoporama", name: "Shoporama", imgSrc: "integration-icons/shoporamaicon.svg" },
        { value: "Magento2", name: "Magento", imgSrc: "integration-icons/magentoicon.svg" }
      ],
      connectorSetup: null,
      connectorSource: {},
      ignoreInvalid: [],
      ready: true,
      connectionError: false,
      connectionMessage: "",
      createdIntegration: null,
      showOkMessage: false,
      loading: false,
      connectedToShop: false,
      noIntegrationOption: false
    };
  },
  computed: {
    valid() {
      return !this.loading;
    },
    primaryButtonMessage() {
      return this.createdIntegration && this.showOkMessage ? this.$t('signupflow.step-2.primary-btn.continue') : this.$t('signupflow.step-2.primary-btn.connect');
    }
  },
  methods: {
    onSubmitIntegration() {
      if (this.connectedToShop) return this.proceed(true);
      this.loading = true;
      if (this.createdIntegration) this.updateIntegrationSettings();
      else this.createIntegration();
    },

    createIntegration() {
      this.$store
        .dispatch("getIntegrationSettings", [this.connectorType])
        .then((res) => {
          // Get settings for the integration the user wants to create
          // add default settings from that integration to the conntectorSettings
          let defaultConfig = {};
          res[appHelper.toCamelCase(this.connectorType)].forEach((setting) => {
            defaultConfig[setting.id] = setting.default;
          });

          let connector = new Connector(this.connectorType, `${this.connectorType} connector`);
          connector.config = {
            ...defaultConfig,
            ...this.connectorSource
          };
          console.log(connector);
          this.$store
            .dispatch("createConnectorFromSignup", connector)
            .then((res) => {
              // When created, check connection status
              // if no connection then ask if all the info is correct
              this.createdIntegration = res.body;
              console.log("created connector", res);
              this.$store.dispatch("testSourceConnection", res.body.id).then((connection) => {
                if (!this.handleConnectionStatus(connection[res.body.id])) {
                  // Give user ability to update their connection
                  this.connectionError = true;
                } else this.$emit("integration-created", this.createdIntegration);
              });
            })
            .finally(() => (this.loading = false));
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    updateIntegrationSettings() {
      let integration = { ...this.createdIntegration };
      for (let key in this.connectorSource) {
        integration.config[key] = this.connectorSource[key];
      }
      this.$store.dispatch("editFixedIntegration", integration).then((res) => {
        this.$nextTick(() => {
          this.createdIntegration = res;
          this.checkUpdatedSourceConnection(this.createdIntegration);
        });
      });
    },

    checkUpdatedSourceConnection(integration, retry = 0) {
      retry = retry + 1;
      this.$store.dispatch("testSourceConnection", integration.id).then((connection) => {
        if (this.handleConnectionStatus(connection[integration.id])) {
          this.$emit("integration-created", integration);
          this.connectionError = false;
          this.showOkMessage = true;
          this.connectedToShop = true;
          this.loading = false;
        } else {
          if (retry > 5) {
            // Give user ability to update their connection 
            this.connectionError = true;
            this.loading = false;
            return;
          }
          setTimeout(() => {
            this.checkUpdatedSourceConnection(integration, retry);
          }, 2000);
        }
      });
    },

    handleConnectionStatus(connection) {
      console.log(connection);
      if (connection == "Ok") return true;
      else {
        this.connectionMessage = connection;
        return false;
      }
    },

    proceed(connected) {
      this.$emit("integration-created", this.createdIntegration, connected);
    },
    cancelFlow() {
      this.$emit("cancel-flow");
    },
    changesMade(i) {
      console.log("changes made", i);
    },

    onCancelFlow() {
      this.noIntegrationOption = true;
      this.connectorType = null;
      // CTA go to platform
    }
  },
  watch: {
    connectorType: {
      handler: function() {
        this.connectorSetup = quickConnectors[this.connectorType];
        this.connectorSource = {};
        this.ready = false;
        this.$nextTick(() => (this.ready = true));
        if (this.connectorSetup) this.noIntegrationOption = false;
      }
    }
  }
};
</script>

<style lang="less">
.step-two {
  .integration-select {
    margin-top: 36px;
  }

  .leave-flow-text {
    margin-top: 8px;
    cursor: pointer;
    text-align: center;
    text-decoration: underline;
    // opacity: 0.5;
  }

  .dynamic-connector-wrapper,
  .no-integration-option {
    display: flex;
    flex-direction: column;
    h3 {
      margin-top: 18px;
      font-family: "Roboto" sans-serif;
    }
    p {
      font-weight: 400;
      line-height: 14px;
    }
    a {
      margin: 18px 0 0 0;
      align-self: center;
      text-decoration: underline;
    }
    .dynamic-form {
      margin-bottom: 24px;
    }
  }

  .no-integration-option {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    margin-top: 18px;
    padding: 18px;
    ul {
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin: 18px 0;
      font-weight: 500;
    }
  }
  .connection-error,
  .ok-message {
    margin-top: 18px;
    button {
      background: none;
      border: none;
      text-decoration: underline;
      padding: 0;
      color: var(--charcoal-75);
      &:hover,
      &:focus {
        color: var(--charcoal);
      }
    }
  }
}
</style>
